<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>用户管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               ref="searchForm"
               label-width="120px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch">
        <div class="re-el-form__flex">
          <el-form-item label="设备号"
                        prop="deviceid">
            <remote-select
              class="width-max"
              clearable
              id-key="id"
              keyword-key="devicenum"
              label-key="devicenum"
              value-key="id"
              placeholder="请输入关键词"
              v-model="search.deviceid"
              :query-request="queryDevices"
              :find-request="getDeviceDetail">
            </remote-select>
          </el-form-item>
          <el-form-item label="零工ID"
                        prop="userid">
            <el-input v-model="search.userid"
                      placeholder="请输入零工用户ID"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="时间范围"
                        prop="last_login_at">
            <el-date-picker v-model="search.last_login_at"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetimerange"
                            :picker-options="dateTimePickerRangeOptions"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            align="center"
                            class="width-max"
                            :default-time="['00:00:00', '23:59:59']"
                            clearable>
            </el-date-picker>
          </el-form-item>
          <el-form-item label="省市区"
                        prop="cityids">
            <el-cascader
              v-model="search.regionids"
              :options="chinaAreaData"
              :props="{ checkStrictly: true }"
              filterable
              clearable >
            </el-cascader>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button @click="resetSearch()">重置</el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>

      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <template v-for="(attr, index) of fields">
          <el-table-column v-if="attr.prop === 'userid'" :key="index" v-bind="attr">
            <template v-slot="scope">
              <el-link type="primary"
                       size="mini"
                       :href="`/users/detail/info?userid=${scope.row.userid}`"
                       :underline="false">
                {{ scope.row.userid }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column v-else :key="index" v-bind="attr" />
        </template>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import table, { removeEmptyParams } from '@core/mixins/table-v3'
import dateTimePicker from '@core/mixins/dateTimePicker'
import { NumberArray } from '@utils/common'

export default {
  mixins: [table, dateTimePicker],
  data () {
    return {
      search: {
        deviceid: null,
        userid: null,
        last_login_at: [],
        regionids: [],
      },
      searchFieldType: {
        userid: Number,
        last_login_at: Array,
        regionids: NumberArray,
      },
      chinaAreaData: [],
    }
  },
  computed: {
    ...Vuex.mapState({
      fields: state => state.users.deviceDetailFields,
    }),
  },
  created () {
    this.getChinaAreaData()
  },
  methods: {
    ...request.map([
      'queryDevices',
      'getDeviceDetail',
    ]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('queryUserDevices', params)
    },
    onExportSearch () {
      this.$export(`${this.$route.meta.title}_搜索结果`, {
        fileHeader: this.fields.map((item) => ({
          key: item.prop,
          text: item.label,
        })),
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: removeEmptyParams(_.cloneDeep(this.search)),
      })
    },
    getChinaAreaData () {
      request.alert('queryAllFormatted').then(({ data }) => {
        this.chinaAreaData = Array.isArray(data) ? data : (Array.isArray(data && data.data) ? data.data : [])
      }).catch(() => {
        this.chinaAreaData = []
      })
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/views/users/pages/detail/UsersDeviceUserListTable.vue